// src/lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      // App offline-first: le queryFn leggono da Dexie quando non c'è rete.
      // Col default 'online' React Query mette in pausa i refetch quando il
      // dispositivo è offline, quindi un invalidateQueries() (es. dopo aver
      // aggiunto un item offline) non rieseguiva la queryFn e la UI non si
      // aggiornava finché non si tornava online. Con 'offlineFirst' la queryFn
      // viene eseguita comunque e legge subito i dati locali. Online invariato.
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
});
